export const Notification = {
    'Copy Link': 'Link copy successfully.',
    'Save project': 'Project saved successfully! Please check your email.',
    'Required file': 'All filed are required.',
    'Product order': 'Product deleted successfully.',
}